import { createContext, FC, PropsWithChildren, useMemo } from "react";

import { appSettings } from "../lib/app-settings";
import { FileProvider } from "../lib/file-provider";

interface AppProviderContextType {
  fileProvider: FileProvider;
}

export const AppProviderContext = createContext<AppProviderContextType>(
  {} as AppProviderContextType,
);

export const AppProvider: FC<PropsWithChildren> = ({ children }) => {
  const ctxValue: AppProviderContextType = useMemo(
    () => ({
      fileProvider: new FileProvider({
        cloudFront: appSettings.aws.cloudFront,
        videoCloudFront: appSettings.aws.videoCloudFront,
        origin: appSettings.api.baseUrl,
      }),
    }),
    [],
  );

  return (
    <AppProviderContext.Provider value={ctxValue}>
      {children}
    </AppProviderContext.Provider>
  );
};
